import { Redirect, Route } from "react-router-dom";
import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

import { AuthenticatedRoute } from "@/components/authenticated-route";

/* Pages */
import SignInPage from "@/pages/sign-in";
import SignUpSelectPage from "@/pages/sign-up";
import SignUpParentsPage from "@/pages/sign-up/parents";
import SignUpProfessionalsPage from "@/pages/sign-up/professionals";
import SignUpRegionalCenterParentsPage from "@/pages/sign-up/regional-center-parents";
import SignUpCompletePage from "@/pages/sign-up/complete";
import SelectMembershipPage from "@/pages/select-membership";
import SongsPage from "@/pages/songs";
import SongPage from "@/pages/songs/[id]";
import GameplayPage from "@/pages/songs/[id]/play";
import VocabularyPage from "@/pages/vocabulary";
import ReportsPage from "@/pages/reports";
import SettingsPage from "@/pages/settings";
import AccountPage from "@/pages/account";
import InviteClientPage from "@/pages/invite-client";
import InviteProfessionalPage from "@/pages/invite-professional";
import InvitationPage from "@/pages/invitations/[id]";
import AddChildPage from "@/pages/add-child";
import HelpPage from "@/pages/help";
import ConfirmEmailPage from "@/pages/confirm-email";
import ForgotPasswordPage from "@/pages/forgot-password";
import ResetPasswordPage from "@/pages/reset-password";
import HomeRedirect from "@/pages/home-redirect";
import { useAppContext } from "./contexts/app-context";

const Routes = () => {
  const { actions: { clearSession } } = useAppContext()

  return (
    <IonReactRouter>
      <IonRouterOutlet>
        <Route exact path="/" component={HomeRedirect} />
        <Route exact path="/sign-in" component={SignInPage} />
        <Route exact path="/sign-up" component={SignUpSelectPage} />
        <Route exact path="/sign-up/parents" component={SignUpParentsPage} />
        <Route
          exact
          path="/sign-up/professionals"
          component={SignUpProfessionalsPage}
        />
        <Route
          exact
          path="/sign-up/regional-center-parents"
          component={SignUpRegionalCenterParentsPage}
        />
        <Route exact path="/confirm-email" component={ConfirmEmailPage} />
        <Route exact path="/forgot-password" component={ForgotPasswordPage} />
        <Route exact path="/reset-password" component={ResetPasswordPage} />

        <AuthenticatedRoute
          exact
          path="/select-membership"
          component={SelectMembershipPage}
        />

        <AuthenticatedRoute
          exact
          path="/sign-up/complete"
          component={SignUpCompletePage}
        />
        <AuthenticatedRoute exact path="/songs" component={SongsPage} />
        <AuthenticatedRoute exact path="/songs/:id" component={SongPage} />
        <AuthenticatedRoute
          exact
          path="/songs/:id/play"
          component={GameplayPage}
        />
        <AuthenticatedRoute
          exact
          path="/vocabulary"
          component={VocabularyPage}
        />
        <AuthenticatedRoute
          exact
          path="/reports"
          component={ReportsPage}
        />
        <AuthenticatedRoute exact path="/settings" component={SettingsPage} />
        <AuthenticatedRoute exact path="/account" component={AccountPage} />
        <AuthenticatedRoute exact path="/invite-client" component={InviteClientPage} />
        <AuthenticatedRoute exact path="/invite-professional" component={InviteProfessionalPage} />
        <AuthenticatedRoute exact path="/add-child" component={AddChildPage} />
        <AuthenticatedRoute exact path="/invitations/:id" component={InvitationPage} />
        <AuthenticatedRoute exact path="/help" component={HelpPage} />

        <Route
          exact
          path="/sign-out"
          render={() => {
            clearSession()

            return <Redirect to="/sign-in" />;
          }}
        />

        <Redirect to="/" />
      </IonRouterOutlet>
    </IonReactRouter>
  );
};

export default Routes;
